var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMappaW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.2142V20.2035C0 20.5349 0.270042 20.8 0.607595 20.8C0.686357 20.8 0.76512 20.789 0.83263 20.7558L6.1097 18.4032V4L0.76512 6.09862C0.303797 6.27535 0 6.71716 0 7.2142ZM8.33755 18.4032L15.6737 20.8V6.39684L8.33755 4V18.4032ZM23.1674 4.04418L17.8903 6.39684V20.8L23.2349 18.7014C23.6962 18.5247 24 18.0828 24 17.5858V4.59645C24 4.26509 23.73 4 23.3924 4C23.3136 4 23.2349 4.01105 23.1674 4.04418Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMappaW);
export default __webpack_public_path__ + "static/media/mappaW.34d21c09d12df324d704c2c01ffa8b18.svg";
export { ForwardRef as ReactComponent };